import { create } from 'zustand'

export type ForcedLayoutMode = 'auto' | 'desktop' | 'mobile'

interface UiState {
    forcedLayout: ForcedLayoutMode
    setForcedLayout: (mode: ForcedLayoutMode) => void
}

export const useUiStore = create<UiState>((set) => ({
    forcedLayout: 'auto',
    setForcedLayout: (mode) => set({ forcedLayout: mode })
}))
